import { defineComponent, ref, computed } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, renderSlot } from 'vue';

var CardPadding;
(function (CardPadding) {
  CardPadding["L"] = "l";
  CardPadding["M"] = "m";
  CardPadding["None"] = "none";
})(CardPadding || (CardPadding = {}));

const CardRoot = [
// Layout
'layout-column',
// Shape
'rounded-md',
// Spacing
'gap-[10px]',
// Typography
'typography-body-2-regular',
// Theme
'theme-background-default dark:theme-background-default-dark', 'shadow-card dark:shadow-card-dark'];
const CardPaddings = {
  [CardPadding.None]: [],
  [CardPadding.L]: ['p-lg'],
  [CardPadding.M]: ['p-md']
};
const CardInteractive = [
// Hover
'hover:shadow-contextual hover:dark:shadow-contextual-dark',
// Selected
'selected:bg-primary-opacity-0-08 dark:selected:bg-primary-opacity-0-08-dark', 'selected:shadow-card selected:dark:shadow-card-dark'];

var script = defineComponent({
  name: 'OrCard',
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: () => CardPadding.M
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-card-v3', ...CardRoot, ...CardPaddings[props.padding], ...(props.interactive ? CardInteractive : [])]);
    return {
      root,
      rootStyles
    };
  }
});

const _hoisted_1 = ["selected"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.selected
  }, [renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-card-v3/OrCard.vue";

export { CardPadding as C, script as s };
